import { Store_order_item } from './store_order_item';
import { Additional_field_response } from '../../additional_field';

export class Store_payment_object {

	order_id: string;
	horse_show_id: string;
	category_number: number;
	credit_card: Credit_card = new Credit_card();
	email_address_for_receipt: string;
	store_item_list: Store_order_item[] = [];
	additional_field_values: Additional_field_response[] = [];
	order_total: number;
}

export class Credit_card {
	
	cardholder_name: string = "";
	card_number: string = "";
	cvv: string = "";
	month: string = "";
	year: string = "";
	zip: string = "";
	country: string = "US";

}